var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"birth",attrs:{"type":"text","data-format":"YYYY-MM-DD","data-template":"D MMMM YYYY","data-max-year":_vm.maxYear,"error-class":_vm.errorClass}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ea9bf40","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/purchases/PartecipantBirthdayInput.vue
// module id = 5QuC
// module chunks = 36